<template>
  <tr>
    <td>{{moment(item.submitDate).format('MM/DD/YYYY')}}</td>
    <td>{{item.programName}}</td>
    <td>{{item.numEvent}}</td>
    <td><span v-if="loadingItem" class="blink-text"><b-spinner></b-spinner>Downloading...</span><a @click="onDownloadFileName(item.fileId, item.fileName)" v-if="!loadingItem">{{item.fileName}}</a></td>
    <td>{{item.errorMessage}}</td>
    <td :class="{ 'textPass': item.result === 'PASS', 'textFailed': item.result === 'FAILED' }">{{item.result}}</td>
  </tr>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import moment from 'moment';

  export default {
    name: 'itemModal',
    props: {
      item: Object,
      clientId: String
    },
    data () {
      return {
        loadingItem: false
      };
    },
    methods: {
      moment (date) {
        return moment(date);
      },
      onDownloadFileName (fileId, fileName) {
        this.loadingItem = true;
        this.downloadUploadedFile({
          fileId: fileId,
          clientId: this.clientId
        }).then(response => {
          const blob = new Blob([response], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
        }).finally(() => {
          this.loadingItem = false;
        });
      },
      ...mapActions({
        downloadUploadedFile: 'ACTION_DOWNLOAD_UPLOADED_FILE'
      })
    },
    computed: {
      ...mapGetters({
        getClientName: 'GETTERS_GET_CLIENT_NAME'
      })
    }
};
</script>


// WEBPACK FOOTER //
// ItemHistoryModal.vue?05febd92